import { useCallback, useRef, useState } from 'react';

const RESIZE_GRIP_SIZE_PX = 16;

const isOnResizeGrip = (event: React.PointerEvent<HTMLElement>) => {
  const { right, bottom } = event.currentTarget.getBoundingClientRect();
  return right - event.clientX <= RESIZE_GRIP_SIZE_PX && bottom - event.clientY <= RESIZE_GRIP_SIZE_PX;
};

export const useDraggedTextareaHeight = () => {
  const [draggedHeight, setDraggedHeight] = useState<number>();
  const textareaReference = useRef<HTMLElement>(null);

  const rememberHeightIfDragged = (event: React.PointerEvent<HTMLElement>) => {
    if (!isOnResizeGrip(event)) {
      return;
    }
    const textarea = event.currentTarget;
    textareaReference.current = textarea;
    const heightBefore = textarea.offsetHeight;
    const minHeightBefore = textarea.style.minHeight;
    textarea.style.height = `${heightBefore}px`;
    textarea.style.minHeight = '';
    document.addEventListener(
      'pointerup',
      () => {
        const heightAfter = textarea.offsetHeight;
        if (heightAfter === heightBefore) {
          textarea.style.minHeight = minHeightBefore;
          return;
        }
        textarea.style.minHeight = `${heightAfter}px`;
        setDraggedHeight(heightAfter);
      },
      { once: true }
    );
  };

  const forgetDraggedHeight = useCallback(() => {
    setDraggedHeight(undefined);
    textareaReference.current?.style.setProperty('height', '1lh');
  }, []);

  return { minHeight: draggedHeight, rememberHeightIfDragged, forgetDraggedHeight };
};
